@if (institutionId > 0) {
  <div id="submodule-invoices" class="cw-module-card">
    <!-- Header -->
    <div class="cw-flex-row">
      <!-- Modul-Titel -->
      @if (!editMode) {
        <h2>{{ 'MODULES.INSTITUTIONS.INVOICES.INVOICES' | translate }}</h2>
      }
      @if (editMode) {
        <h2>{{ 'MODULES.INSTITUTIONS.INVOICES.INVOICEOVERVIEW' | translate }}</h2>
      }
      <!-- Toolbar -->
      @if (!editMode) {
        <phscw-toolbar
          componentIdentifier="institutions-invoices"
          [componentConnection]="$any(this)"
          [buttonFilterInvoices]="true">
        </phscw-toolbar>
      }
      @if (editMode) {
        <phscw-toolbar
          componentIdentifier="institutions-invoices"
          [componentConnection]="$any(this)"
          [buttonCancel]="true">
        </phscw-toolbar>
      }
    </div>
    <!-- Grid (zeigt Rechnungen der aktuellen Einrichtung) -->
    @if (!editMode) {
      <phscw-grid
        #gridInstitutionsInvoices
        gridId="institutionsInvoices"
        [simpleGrid]="true"
        [gridData]="dataInvoicesList"
        [gridColumns]="gridColumns"
        [gridDisplayedColumns]="gridDisplayedColumns">
      </phscw-grid>
    }
    <!-- Funktion um weitere Einträge zu laden -->
    @if (!editMode) {
      <phscw-grid-load-more
        gridId="institutionsInvoices"
        [enabled]="loadMoreEnabled"
        [visible]="loadMoreVisible"
        [gridPageCounter]="gridPage">
      </phscw-grid-load-more>
    }
    <!-- Details einer Rechnung -->
    @if (editMode) {
      <div [ngClass]="detailsLoading ? 'icon-spinner icon-spin' : ''"></div>
      @if (!detailsLoading) {
        <div class="cw-flex-row cw-input">
          <span class="cw-input-label">{{ 'GENERAL.ORDER' | translate }}</span>
          <div class="cw-flex-column">
            <span class="cw-input-span">{{ dataInvoicesPositions[0].order_erp_number }}</span>
          </div>
        </div>
        @if (dataInvoicesPositions[0].invoice_erp_number) {
          <div class="cw-flex-row cw-input">
            <span class="cw-input-label">{{ 'MODULES.INSTITUTIONS.INVOICES.INVOICENUMBER' | translate }}</span>
            <div class="cw-flex-column">
              <span class="cw-input-span">{{ dataInvoicesPositions[0].invoice_erp_number }}</span>
            </div>
          </div>
        }
        <div class="cw-flex-row cw-input">
          <span class="cw-input-label">{{ 'GENERAL.DATE' | translate }}</span>
          <div class="cw-flex-column">
            <span class="cw-input-span">{{ dataInvoicesPositions[0].invoice_date | date: 'dd.MM.yyyy' }}</span>
          </div>
        </div>
        <div class="cw-flex-row cw-input">
          <span class="cw-input-label">{{ 'GENERAL.REGION' | translate }}</span>
          <div class="cw-flex-column">
            <span class="cw-input-span">
              @if (dataInvoicesPositions[0].region) {
                @if (dataInvoicesPositions[0].region.regionkey) {
                  {{ dataInvoicesPositions[0].region.regionkey }}
                  }{{ dataInvoicesPositions[0].region.name }}
                } @else {
                  {{ dataInvoicesPositions[0].region_id }} (unbekannt)
                }
              </span>
            </div>
          </div>
          <div class="cw-flex-row cw-input">
            <span class="cw-input-label">{{ 'MODULES.INSTITUTIONS.SALES.TOTALSUM' | translate }}</span>
            <div class="cw-flex-column">
              <span class="cw-input-span">{{ dataInvoicesTotal | number: '1.2-2' }}&nbsp;{{ currency }}</span>
            </div>
          </div>
          <phscw-grid
            #gridInstitutionsInvoicesPositions
            gridId="institutionsInvoicesPositions"
            [simpleGrid]="true"
            [gridData]="dataInvoicesPositions"
            [gridColumns]="gridColumnsPositions"
            [gridDisplayedColumns]="gridDisplayedColumnsPositions">
          </phscw-grid>
        }
      }
    </div>
  }
